import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Ship} from '../../Ship';

@Component({
  selector: 'app-ship-search-results',
  templateUrl: './ship-search-results.component.html',
  styleUrls: ['./ship-search-results.component.css']
})
export class ShipSearchResultsComponent implements OnInit {
  @Input() results: Ship[];
  @Output() shipSelected: EventEmitter<Ship> = new EventEmitter();

  constructor() { }

  ngOnInit() {

  }

  selectShip(ship: Ship) {
    this.shipSelected.emit(ship);
  }

}
